

















































import Vue from "vue";
import FormComponentMixin from "@/plugins/FormComponentMixin";
export default Vue.extend({
  mixins: [FormComponentMixin],
  props: {
    confirm: { default: true },
    label: { default: "" },
    required: { default: false },
    context: {
      default() {
        return ((this as unknown) as { defaultContext: "string" })
          .defaultContext;
      }
    },
    staticField: { default: false }
  },
  inject: {
    defaultContext: { default: "single" }
  },
  data() {
    return {
      isLoading: false,
      violations: {},
      phase: "input"
    };
  }
});
